export class GatewayRadiusModel {
   radiusMeters:number;
   multiplier:number;

   readonly radiusOptions = [
      { label: 'Meters', value: 1 },
      { label: 'Kilometers', value: 0.001 },
      { label: 'Miles', value: 0.000621371 }
   ];

   constructor(radiusMeters:number, multiplier:number) {
      this.radiusMeters = radiusMeters;
      this.multiplier = multiplier;
   }

   get radius() {
      return parseFloat((this.radiusMeters * this.multiplier).toFixed(2));
   }

   set radius(radius:number) {
      this.radiusMeters = Math.round(radius / this.multiplier);
   }
}